export function requestNginxCachePurge() {
  if (!process.client || typeof window === "undefined") {
    return Promise.resolve(false);
  }

  return fetch("/nuxt-cache-purge", {
    method: "POST",
    credentials: "same-origin",
  })
    .then(async (response) => {
      const result = await response.json().catch(() => ({}));
      if (!response.ok || result.success === false) {
        console.warn("[nginx-cache-purge] server skipped purge:", result.message || response.status);
        return false;
      }
      return true;
    })
    .catch((error) => {
      console.warn("[nginx-cache-purge] request failed:", error);
      return false;
    });
}
